import { isRejectedWithValue, Middleware } from "@reduxjs/toolkit";
import { authRedux } from "@store";
import { clearGuestToken } from "./guestToken";

export const rtkQueryErrorHandler: Middleware =
  ({ dispatch }) =>
  (next) =>
  (action) => {
    if (isRejectedWithValue(action)) {
      // Ağ hatalarında payload undefined olabilir, doğrudan erişim patlar.
      const status = (action.payload as { status?: number } | undefined)
        ?.status;

      if (process.env.NODE_ENV !== "production") {
        console.warn("API Query Error: ", action);
      }

      if (status === 401 || status === 403) {
        // Misafir token'ı sunucu tarafında geçersiz kılınmış olabilir;
        // temizlenirse sonraki istek yenisini alır.
        clearGuestToken();
        dispatch(authRedux.logout());
      }
    }

    return next(action);
  };
